import { Formik } from "formik";
import { Col, Row } from "taltech-styleguide";
import { InputDescription, InputName } from "@components-common/forms";
import { SubmitBtn } from "../../ProgressButtons";
import { useWizard } from "../../wizard/context";
import associateBuildStudentSchema from "./associate-build-student.schema";
import { ProgressWizardStepForm } from "../../wizard/ProgressWizardStepForm";

export const StudentFormSubmission = ({ ...props }) => {
  const wizard = useWizard();
  const { title, element } = props;

  return (
    <ProgressWizardStepForm
      title={title}
      element={element.configInformation}
      schema={associateBuildStudentSchema}
    >
      <MainContent />
    </ProgressWizardStepForm>
  );
};

const MainContent = () => {
  return (
    <>
      <Row>
        <Col sm="12" md="6">
          <InputName             elementClass="required" />
          <InputDescription />
        </Col>
      </Row>
    </>
  );
};
